<!-- 自定义元数据组件 -->
<template>
  <div class="CustomMetadata">
    <div class="CustomMetadataHead">
      <div class="name">
        {{$t('lang.CustomMetadataValue')}}
      </div>
      <div @click="CustomMetadataCancel">
        <i class="iconfont icon-a-closethick"></i>
      </div>
    </div>
    <div class="CustomMetadataContent">
      <div class="CustomContent">
        <div class="CustomTitle">{{$t('lang.key')}}</div>
        <div class="CustomTitle">{{$t('lang.value')}}</div>
      </div>
      <div class="CustomContent" v-for="(item, index) in CustomMetadataList" :key="index">
        <div class="Customcheckbox" @click="item.check = !item.check">
          <i class="iconfont icon-checkbox1" v-if="item.check"></i>
          <i class="iconfont icon-yduifuxuankuang" v-else></i>
        </div>
        <div class="key">{{item.key}}</div>
        <div class="value"><el-input v-model="item.value"></el-input></div>
      </div>
    </div>
    <div class="CustomMetadataBottom">
      <el-button
          size="small"
          class="cancelButton"
          @click="CustomMetadataCancel">{{ $t("lang.cancel") }}</el-button>
        <el-button
          size="small"
          type="primary"
          class="saveButton"
          @click="CustomMetadataSave">{{ $t("lang.ConfirmBtn") }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomMetadata',
  props: {
    // setting设置的key
    CustomMetadataData: {
      type: String,
      default: ''
    },
    // 选中的key和value
    SelectCustomMetadata: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      CustomMetadataList: []
    }
  },
  created () {
    this.TypeTransition()
  },
  mounted () {

  },
  methods: {
    // 类型转换
    TypeTransition () {
      const CustomData = this.SelectCustomMetadata ? JSON.parse(JSON.stringify(this.SelectCustomMetadata)) : {}
      const CustomDataKey = (this.CustomMetadataData && this.CustomMetadataData.length) ? this.CustomMetadataData.split(',') : []
      this.CustomMetadataList = []
      CustomDataKey.forEach((item) => {
        if (CustomData[item] == undefined) {
          this.CustomMetadataList.push({
            check: false,
            key: item,
            value: ''
          })
        } else {
          this.CustomMetadataList.push({
            check: true,
            key: item,
            value: CustomData[item]
          })
          CustomData[item] = undefined
        }
      })
      Object.keys(CustomData).forEach((key) => {
        if (CustomData[key] != undefined) {
          this.CustomMetadataList.push({
            check: true,
            key: key,
            value: CustomData[key]
          })
        }
      })
    },
    // 自定义数据取消
    CustomMetadataCancel () {
      this.$emit('SelectCustomMetadataEnd')
    },
    // 自定义数据保存
    CustomMetadataSave () {
      const SaveData = {}
      this.CustomMetadataList.forEach((item) => {
        if (item.check) {
          SaveData[item.key] = item.value
        }
      })
      this.$emit('SelectCustomMetadataEnd', SaveData)
    }
  }
}
</script>

<style scoped lang="less">
.CustomMetadata {
  width: 400px;
  padding: 0 24px;
  background: #252525;
  border-radius: 6px;
  position: absolute;
  left: -110px;
  top: 30px;
  z-index: 10;
  .CustomMetadataHead{
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #444444;
    font-size: 16px;
    color: #DBDBDB;
  }
  .CustomMetadataContent{
    max-height: 353px;
    overflow: auto;
    .CustomContent{
      display: flex;
      justify-content: flex-end;
      margin-bottom: 12px;
      line-height: 32px;
      .Customcheckbox{
        margin-right: 20px;
        line-height: 32px;
        .icon-checkbox1{
          color: #38AB52;
        }
        .icon-yduifuxuankuang{
          color: #999;
        }
        i {
          font-size: 14px;
        }
      }
      .CustomTitle{
        width: 139px;
        height: 28px;
        margin-right: 18px;
      }
      .key{
        width: 139px;
        height: 32px;
        margin-right: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .value{
        width: 139px;
        height: 32px;
        margin-right: 18px;
        ::v-deep .el-input__inner{
          padding-left: 8px;
        }
      }
    }
  }
  .CustomMetadataBottom{
    text-align: right;
    margin: 24px 0;
    button {
      width: 80px;
      height: 32px;
    }
  }
}

</style>
